import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _vm.isEmptyTable
        ? _c("StateComponent", {
            attrs: {
              state: "empty_state",
              title: _vm.$t("my_objects.states_objects.no_tables"),
              subtitle: _vm.$t("my_objects.states_objects.no_tables_subtitle"),
            },
          })
        : _c(
            VCard,
            [
              _vm.queryResponse.tables && _vm.queryResponse.tables.length >= 0
                ? _c(VDataTable, {
                    key: _vm.key_table,
                    ref: "my-tables-operator",
                    staticClass: "text-center table-inca",
                    style: { "font-size": "11px" },
                    attrs: {
                      responsive: "",
                      hover: "",
                      items: _vm.queryResponse.tables || [],
                      "sort-by.sync": "columns_change",
                      "sort-desc.sync": "true",
                      headers: _vm.getTableFields(),
                      "sticky-header": true,
                      "show-empty": "",
                      "hide-default-footer": true,
                      page: _vm.pagination.current,
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "empty",
                          fn: function (scope) {
                            return [_vm._v(_vm._s(_vm.messageEmptyList))]
                          },
                        },
                        {
                          key: "item.tableReference_tableId",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("div", { staticClass: "text-left" }, [
                                _c("b", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "table-name",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openEditTpl(
                                            item,
                                            _vm.MODAL_NAME_METADATA_VIEW
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(item.tableReference.tableId)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _c("br"),
                                _c(
                                  "a",
                                  {
                                    staticClass: "compose-name",
                                    attrs: { title: item.id },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openEditTpl(
                                          item,
                                          _vm.MODAL_NAME_METADATA_VIEW
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "caption" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("joinTableReference")(
                                            item.tableReference
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.creationTime",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("span", { staticClass: "date-format" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(item.creationTime)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.numRows",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("span", { staticClass: "date-format" }, [
                                _vm._v(
                                  _vm._s(_vm._f("formatNumber")(item.numRows))
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.schema_fields_length",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.hover.bottom",
                                      value: item.columns_change
                                        ? "One or more columns were changed or added!"
                                        : "",
                                      expression:
                                        "item.columns_change ? 'One or more columns were changed or added!':''",
                                      modifiers: { hover: true, bottom: true },
                                    },
                                  ],
                                  class: item.columns_change
                                    ? "text-danger font-weight-bold"
                                    : "",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.schema && item.schema.fields
                                        ? item.schema.fields.length
                                        : 0
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "btn-icon-inca",
                                                    attrs: {
                                                      small: "",
                                                      icon: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openEditTpl(
                                                          item,
                                                          _vm.MODAL_NAME_METADATA
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("icon-edit")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("my_objects.update_metadata")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            !_vm.approvalFlow &&
                                            item.defaultFields &&
                                            _vm.toLower(
                                              item.defaultFields.operator
                                                .stringValue
                                            ) == _vm.currentEmail
                                              ? _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          icon: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.asyncTableWithSchema(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      VIcon,
                                                      { attrs: { small: "" } },
                                                      [_vm._v("mdi-restore")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("my_objects.sync"))),
                                  ]),
                                ]
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            false
                                              ? _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          small: "",
                                                          icon: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.generateViewUrl(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      VIcon,
                                                      { attrs: { small: "" } },
                                                      [_vm._v("icon-view")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("my_objects.bigquery"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "btn-icon-inca",
                                                    attrs: {
                                                      small: "",
                                                      icon: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openModal(
                                                          item.tableReference,
                                                          _vm.MODAL_LIST_ACCESS
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("mdi-lock")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("my_objects.manage_access"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "btn-icon-inca",
                                                    attrs: {
                                                      id:
                                                        "popover-more-actions-" +
                                                        item.id,
                                                      small: "",
                                                      icon: "",
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("mdi-menu")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("my_objects.more_actions"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "b-popover",
                                {
                                  ref: "popover",
                                  attrs: {
                                    target: "popover-more-actions-" + item.id,
                                    triggers: "hover",
                                    placement: "bottom",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "title",
                                        fn: function () {
                                          return [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass: "close",
                                                attrs: {
                                                  "aria-label": "Close",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "d-inline-block",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  },
                                                  [_vm._v("×")]
                                                ),
                                              ]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_objects.more_actions"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                !_vm.approvalFlow &&
                                                item.defaultFields &&
                                                item.defaultFields.env.enumValue
                                                  .displayName === "prod" &&
                                                _vm.toLower(
                                                  item.defaultFields.operator
                                                    .stringValue
                                                ) == _vm.currentEmail
                                                  ? _c(
                                                      VBtn,
                                                      {
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          small: "",
                                                          icon: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openTempOwner(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          VIcon,
                                                          {
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-account-multiple"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("my_objects.set_temporal_do")
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                !_vm.approvalFlow &&
                                                item.defaultFields &&
                                                item.defaultFields.env.enumValue
                                                  .displayName === "prod" &&
                                                _vm.toLower(
                                                  item.defaultFields.operator
                                                    .stringValue
                                                ) == _vm.currentEmail
                                                  ? _c(
                                                      VBtn,
                                                      {
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          small: "",
                                                          icon: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openModal(
                                                              item.tableReference,
                                                              _vm.MODAL_PROFILING_RULES
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          VIcon,
                                                          {
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-chart-bar"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("my_objects.profiling"))
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3096648230
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
      !_vm.isEmptyTable
        ? _c("pagination-firestore", {
            key: _vm.key_pagination,
            attrs: { pagination: _vm.pagination, pageType: "1" },
            on: { changePagina: _vm.changePage },
          })
        : _vm._e(),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_METADATA,
          attrs: { title: _vm.$t("my_objects.metadata"), width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-table-component", {
                ref: "metadataTableRef",
                attrs: {
                  tplToWork: _vm.tplToUpdate,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.CHANGE_REQUEST,
                  showAuthorizationTypeField: true,
                },
                on: {
                  submit: _vm.saveTags,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.metadataTableRef.validateForm(
                        "ok",
                        $event
                      )
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(_vm._s(_vm.$t("btns.request"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_METADATA_VIEW,
          attrs: { title: _vm.$t("my_objects.metadata"), width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-table-component", {
                ref: "viewmetadataTableRef",
                attrs: {
                  tplToWork: _vm.tplToUpdate,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                  lazyLoadParams: _vm.lazyLoadParamsForViewer,
                },
                on: {
                  submit: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA_VIEW].onClose()
                  },
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA_VIEW].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsLeft" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "secondary", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.viewmetadataTableRef.clickDownloadCSV()
                    },
                  },
                },
                [
                  _c(VIcon, [_vm._v("icon-download")]),
                  _vm._v(_vm._s(_vm.$t("btns.download_metadata"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_OWNER,
          attrs: { title: _vm.$t("my_objects.set_temporal_do") },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-assign-temporal-owner", {
                ref: _vm.MODAL_NAME_OWNER + "_body",
                attrs: { tplToWork: _vm.tplToUpdate },
                on: {
                  submit: _vm.assignOwner,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_OWNER].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_NAME_OWNER + "_body"].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { icon: "" } }, [
                    _vm._v("mdi-check-all"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.assign"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_ALL_OWNER,
          attrs: { title: _vm.$t("my_objects.assign_all_do") },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-assign-temporal-owner", {
                ref: _vm.MODAL_NAME_ALL_OWNER + "_body",
                attrs: { isForAllOwners: true, source: _vm.source },
                on: {
                  submit: _vm.assignAllOwner,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_ALL_OWNER].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_NAME_ALL_OWNER + "_body"].onSubmit(
                        $event
                      )
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { icon: "" } }, [
                    _vm._v("mdi-check-all"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.assign"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_PROFILING_VIEW,
          attrs: { title: _vm.$t("my_objects.data_profiling"), width: 950 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("history-item", {
                attrs: { item: _vm.item, readonly: true },
                on: {
                  closeModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_PROFILING_VIEW].onClose()
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_CONFIRM_EXECUTE_PROFILING,
          attrs: { title: _vm.$t("my_objects.execute_profiling"), width: 950 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("profiling-execute-item", {
                attrs: { item: _vm.tableExecute },
                on: { closeExecuteItem: _vm.closeExecuteItem },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_PROFILING_RULES,
          attrs: { title: _vm.$t("my_objects.choose_profiling"), width: 950 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("modal-profiling-rules", {
                attrs: { tableReference: _vm.tableReference },
                on: { viewDetail: _vm.viewDetail },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_LIST_ACCESS,
          attrs: { title: _vm.$t("my_objects.access_table"), width: 950 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("modal-access", {
                attrs: {
                  tableReference: _vm.tableReference,
                  source: _vm.source,
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }